module.exports = __webpack_public_path__ + "img/Img2@2x.c0bb20ab.jpg";